import { useUiStore } from 'hooks/useUiStore';
import { useDispatch, useSelector } from 'react-redux';
import { getEncuesta, getPreguntasHijas, getVerificaEncuesta, postEncuesta } from 'services/encuestaService/encuestaService';
import { setIsLoading, setMessageLoading, setOpenSnackBar } from 'store';
import { onActiva, onDatosEncuesta, onEncuestaOpen, onLstRespuesta, onPregunta, onPreguntasHijas } from 'store/encuestas/encuestaCalidadSlice';
import { RootState } from 'store/store';
import Swal from 'sweetalert2';

export const useEncuestaCalidad = () => {
    const dispatch = useDispatch();
    const { isEncuestaOpen, preguntas, lstRespuestas, respUsuario, datosEncuesta, preguntasHijas, isActiva } = useSelector((state: RootState) => state.encuestaCalidad)
    const { user } = useSelector((state: RootState) => state.auth);
    const { optionsSnackBar } = useUiStore();

    const startGetVerificacion = (idEncuesta: number, cveUsuario: number) => {
        getVerificaEncuesta(idEncuesta, cveUsuario)
            .then(({ data }) => {

                if (data?.data?.encuestaUsuario === null) {
                    setEncuestaOpen(true)
                } else {
                    setEncuestaOpen(false)
                }
                if(data?.data?.encuestaActiva=== "S"){
                    setActivo(true); 
                }else{
                    setActivo(false)
                }
            })
            .catch((err) => {
                console.log(err);
                setEncuestaOpen(false);
                setActivo(false);
                // dispatch(
                //     setOpenSnackBar({
                //         status: true,
                //         message: err.response.data.data,
                //         optionsSnackBar: {
                //             ...optionsSnackBar,
                //             type: "error",
                //         },
                //     })
                // );
            });
    }
    const startGetEncuesta = (idEncuesta: number) => {
        getEncuesta(idEncuesta)
            .then(({ data }) => {
                dispatch(onDatosEncuesta(data?.data?.encuesta));
                const preguntas = data?.data?.preguntas?.map((ask: any) => ({
                    pregunta: ask?.descPregunta,
                    idPregunta: ask?.idPregunta,
                    cveSeccion: ask?.cveSeccion,
                    respuestas: ask?.respuestas?.map((respuesta: any) => ({
                        idPregunta: respuesta?.idPregunta,
                        idRespuesta: respuesta?.idRespuesta,
                        descripcion: respuesta?.descRespuesta,
                        despliega: respuesta?.despliegaPregunta
                    })),
                }));
                getPreguntas(preguntas);
            })
            .catch((err) => {
                console.log(err);
                dispatch(
                    setOpenSnackBar({
                        status: true,
                        message: err.response.data.data,
                        optionsSnackBar: {
                            ...optionsSnackBar,
                            type: "error",
                        },
                    })
                );
            });
    }
    const startPostEncuesta = (body: any) => {
        dispatch(setMessageLoading("Guardando..."));
        dispatch(setIsLoading(true));
        postEncuesta(body)
            .then(({ data }) => {
                dispatch(setMessageLoading(""));
                dispatch(setIsLoading(false));
                setEncuestaOpen(false);
                Swal.fire({
                    title: "Correcto",
                    text: "Encuesta finalizada con exito. Gracias por tu participación",
                    icon: "success",
                });

            })
            .catch((err) => {
                setEncuestaOpen(false);
                dispatch(setMessageLoading(""));
                dispatch(setIsLoading(false));
                dispatch(
                    setOpenSnackBar({
                        status: true,
                        message: err.response.data.data,
                        optionsSnackBar: {
                            ...optionsSnackBar,
                            type: "error",
                        },
                    })
                );
                Swal.fire({
                    title: "Error",
                    text: err?.response?.data?.error_msg,
                    icon: "warning",
                });
                startGetVerificacion(body?.idEncuesta, body?.idPersonaAutorizada)
            });
    }
    const startGetPreguntas = (idPregunta: number) => {
        dispatch(setMessageLoading("Consultando..."));
        dispatch(setIsLoading(true));
        getPreguntasHijas(idPregunta)
            .then(({ data }) => {
                const preguntas = data?.data?.map((ask: any) => ({
                    pregunta: ask?.descPregunta,
                    idPregunta: ask?.idPregunta,
                    idPreguntaPadre: ask?.idPreguntaPadre,
                    respuestas: ask?.respuestas?.map((respuesta: any) => ({
                        idPregunta: respuesta?.idPregunta,
                        idRespuesta: respuesta?.idRespuesta,
                        descripcion: respuesta?.descRespuesta,
                        despliega: respuesta?.despliegaPregunta
                    })),
                }));
                getAskHijas(preguntas);
                dispatch(setMessageLoading(""));
                dispatch(setIsLoading(false));
            })
            .catch((err) => {
                console.log(err);
                getAskHijas([]);
                dispatch(setMessageLoading(""));
                dispatch(setIsLoading(false));
                dispatch(
                    setOpenSnackBar({
                        status: true,
                        message: err.response.data.data,
                        optionsSnackBar: {
                            ...optionsSnackBar,
                            type: "error",
                        },
                    })
                );
            });
    }

    const setEncuestaOpen = (bandera: boolean) => dispatch(onEncuestaOpen(bandera));
    const setActivo = (bandera: boolean) => dispatch(onActiva(bandera));
    const getPreguntas = (preguntas: any) => dispatch(onPregunta(preguntas));
    const getAskHijas = (preguntas: any) => dispatch(onPreguntasHijas(preguntas))
    const getLstRespuestas = (respuestaLst: any) => dispatch(onLstRespuesta(respuestaLst));
    return {
        // props
        isEncuestaOpen,
        isActiva,
        user,
        preguntas,
        lstRespuestas,
        respUsuario,
        datosEncuesta,
        preguntasHijas,
        //methods
        setEncuestaOpen,
        setActivo,
        getPreguntas,
        getAskHijas,
        getLstRespuestas,
        startGetEncuesta,
        startGetPreguntas,
        startPostEncuesta,
        startGetVerificacion
    }
}
